import { Box, Stack, Typography } from '@mui/material';
import { NotificationsCardIcon } from './NotificationsIcon';
import { notificationStyles } from '~/shared/theme/theme';
import { NotificationIconType, NotificationUrgency } from './types';
import { NotificationDateMetadata } from './NotificationDateMetadata';

interface NotificationCardHeaderProps {
  type: NotificationIconType;
  urgency: NotificationUrgency;
  title: string;
  alertDescription?: string;
  typeLabel: string;
  date: string;
  resolvedDate?: string;
  isResolved?: boolean;
}

export function NotificationCardHeader({
  type,
  urgency,
  title,
  typeLabel,
  alertDescription,
  date,
  resolvedDate,
  isResolved = false,
}: NotificationCardHeaderProps) {
  return (
    <>
      <Stack direction="row" spacing={3} mb={4}>
        <NotificationsCardIcon
          iconType={type}
          urgency={urgency}
          isResolved={isResolved}
        />

        <Box sx={{ minWidth: 0, wordBreak: 'break-word' }}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600 }}
            color="primary.dark"
          >
            {title}
          </Typography>
          <NotificationDateMetadata
            typeLabel={typeLabel}
            date={date}
            resolvedDate={resolvedDate}
            isResolved={isResolved}
          />
        </Box>
      </Stack>
      {alertDescription && (
        <Typography
          variant="body2"
          color={notificationStyles.lightText}
          sx={{ mb: 4 }}
          fontWeight={400}
        >
          {alertDescription}
        </Typography>
      )}
    </>
  );
}
